import variants from "@/assets/hero-park-hyatt.jpg?w=640;960;1280;1920;2560&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";

export const heroPhoto = responsiveImage(variants);
